//dependencias
import React, { Component } from 'react';

//componentes
import EscalaLiteralAction from './escalaLiteral'

class Index extends Component {

    render(){
        return(
            <div>
                <EscalaLiteralAction />
            </div>
        );
    }

}
export default Index;